import { api } from "./axios";
import type { PlaybackFile } from "../types";

export async function searchRecordings(args: {
  device_id: number;
  channel: number;
  start: string;
  end: string;
  stream?: "Main" | "Extra1";
}): Promise<{ files: PlaybackFile[] }> {
  const r = await api.post("/playback/search", { ...args, stream: args.stream || "Main" });
  return r.data;
}

export async function startPlayback(args: {
  device_id: number;
  channel: number;
  start: string;
  end: string;
  speed?: number;
  transcode?: boolean;
}) {
  const r = await api.post("/playback/start", args);
  return r.data as { playback_id: string; stream_name: string; ws_url: string };
}

export async function stopPlayback(playback_id: string) {
  await api.post("/playback/stop", { playback_id, action: "stop" });
}

// Lista de dias (YYYY-MM-DD) con al menos una grabacion en el rango. El frontend
// la usa para pintar los puntos verdes del calendario.
export async function availableDays(args: {
  device_id: number;
  channel: number;
  start: string;
  end: string;
  stream?: "Main" | "Extra1";
}): Promise<{ days: string[] }> {
  const r = await api.post("/playback/available-days", {
    ...args,
    stream: args.stream || "Main",
  });
  return r.data;
}
